export enum InternalExamSource {
  Independent = 0,
  Osk = 1,
}

export enum InternalExamResult {
  Undefined = 0,
  PassedByOsk = 1,
  PassedAutomatically = 2,
  FailedByOsk = 3,
  FailedAutomatically = 4,
}

export interface IOskStudentWordExamResultIm {
  wordExamGuid: string;
  result: InternalExamResult;
}
